import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from '../../../../store/actions/main';
import {updateStepsVordaecher,
        selectPfostenVordaecher
        } from '../../../../store/actions/vordaecher';
import {Textfield} from '../../../../module/textField';


const Step_Pfosten = (props) => {

    const [pfosten, updatePfosten_Form] = useState('');

    useEffect(() => {
        updateItems();
    })

   const updateItems = () => {
        const {pfosten} = props.data[3];

        //update pfosten form
        updatePfosten_Form(pfosten);

        //update steps
        props.updateSteps(2);

        if(pfosten || props.data[3].allVisitedSteps) {
            props.updateSteps(3);
            props.setUpdateButtonActiveStepToFalse();
        } else {
            props.setUpdateButtonActiveStepToTrue()
        }

   }

   const updatePfostenForm = ev => {
        let pfosten_form = ev.target.value;
        props.selectPfosten(pfosten_form);
        updateItems();
   }

   let pfosten_form_options = [
       {titel: 'Rundrohr 42,4 mm'},
       {titel: 'Rundrohr 60 mm'},
       {titel: 'Rechteck 50 x 30 mm'},
       {titel: 'Quadraht 40 x 40 mm'},
       {titel: 'Quadraht 60 x 60 mm'}

   ];

    return (
        <div className="step_wrapper">
              <div className="step_icon_wrapper">
              <h2 className="step_header">Form der Pfosten</h2>
                <div className="inner_textfield_wrapper">
                    <Textfield
                         label="Bitte wählen"
                         type="text"
                         select
                         rowsMax={1}
                         value={pfosten}
                         onChange={updatePfostenForm}
                         array_options={pfosten_form_options}
                         name='Pfosten'
                    />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        data: state.vordaecherReducer.data
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updateSteps: ev => dispatch(updateStepsVordaecher(ev)),
      selectPfosten: ev => dispatch(selectPfostenVordaecher(ev))

   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_Pfosten);
